export const populationByRegions = [{
  region: 'dato 1',
  val: 4119626293
}, {
  region: 'dato 2',
  val: 1012956064
}];
